var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoices" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Official — Instagram Content Publishing")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/instagram/accounts/list" } },
                          [_vm._v("List Accounts")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Add Account")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 col-lg-6 col-xl-6 d-flex" }, [
                _c("div", { staticClass: "card container" }, [
                  _c("div", { staticClass: "row align-items-center h-100" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  id: "ajax",
                                  label: "brand_name",
                                  "track-by": "id",
                                  placeholder: "Type to search Brand...",
                                  multiple: true,
                                  "open-direction": "bottom",
                                  "custom-label": _vm.customLabel,
                                  options: _vm.contactOptions,
                                  searchable: true,
                                  loading: _vm.isLoading,
                                  "internal-search": false,
                                  "close-on-select": false,
                                  "options-limit": 300,
                                  limit: 3,
                                  "limit-text": _vm.limitText,
                                  "max-height": 600,
                                  "show-no-results": true,
                                  "hide-selected": true,
                                  "show-labels": false
                                },
                                on: { "search-change": _vm.asyncFind },
                                scopedSlots: _vm._u([
                                  {
                                    key: "tag",
                                    fn: function(ref) {
                                      var option = ref.option
                                      var remove = ref.remove
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "custom__tag" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(option.name))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "custom__remove",
                                                on: {
                                                  click: function($event) {
                                                    return remove(option)
                                                  }
                                                }
                                              },
                                              [_vm._v("❌")]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "clear",
                                    fn: function(props) {
                                      return [
                                        _vm.selectedContact.length
                                          ? _c("div", {
                                              staticClass: "multiselect__clear",
                                              on: {
                                                mousedown: function($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.clearAll(
                                                    props.search
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.selectedContact,
                                  callback: function($$v) {
                                    _vm.selectedContact = $$v
                                  },
                                  expression: "selectedContact"
                                }
                              },
                              [
                                _vm._v(" "),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult"
                                  },
                                  [_vm._v("Oops! No elements found.")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.selectedContact.length
                        ? _c("div", { staticClass: "text-center" }, [
                            _vm.loadingFB
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "20px" } },
                                  [_vm._v("Sedang mengalihkan...")]
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.FBComponent.scope.logout &&
                                    _vm.FBComponent.model.connected
                                      ? _c("v-facebook-login", {
                                          staticClass:
                                            "btn-default-costume btn-facebook",
                                          style: "width:100%;margin-top:10px;",
                                          attrs: {
                                            type: "button",
                                            "app-id": _vm.FBComponent.appId,
                                            "use-alt-logo": true,
                                            tabindex: "6",
                                            version: "v16.0",
                                            "login-options":
                                              _vm.FBComponent
                                                .scopeInstagramPermissionsInsight
                                          },
                                          on: {
                                            "sdk-init": _vm.handleSdkInit,
                                            login: _vm.handleSdkLogin
                                          },
                                          model: {
                                            value: _vm.FBComponent.model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.FBComponent,
                                                "model",
                                                $$v
                                              )
                                            },
                                            expression: "FBComponent.model"
                                          }
                                        })
                                      : _c("v-facebook-login", {
                                          staticClass:
                                            "btn-default-costume btn-facebook",
                                          style: "width:100%;margin-top:10px;",
                                          attrs: {
                                            type: "button",
                                            tabindex: "6",
                                            "app-id": _vm.FBComponent.appId,
                                            "use-alt-logo": true,
                                            version: "v16.0",
                                            "login-options":
                                              _vm.FBComponent
                                                .scopeInstagramPermissionsInsight
                                          },
                                          on: {
                                            "sdk-init": _vm.handleSdkInit,
                                            login: _vm.handleSdkLogin
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "login",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      "Masuk Dengan Facebook"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            1251041968
                                          ),
                                          model: {
                                            value: _vm.FBComponent.model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.FBComponent,
                                                "model",
                                                $$v
                                              )
                                            },
                                            expression: "FBComponent.model"
                                          }
                                        })
                                  ],
                                  1
                                )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [_vm._v(" ")])
                  ])
                ])
              ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-6 col-xl-6 d-flex" }, [
      _c("div", { staticClass: "card flex-fill" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("h4", { staticClass: "card-title" }, [
            _vm._v("Content Publishing")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statistics" }, [
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "You can use the Instagram Graph API to publish single images, videos, reels (i.e. single media posts), or posts containing multiple images and videos (carousel posts) on Instagram Business accounts."
              )
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "card-title" }, [_vm._v("Limitations")]),
            _vm._v(" "),
            _c("ul", { staticClass: "text-muted" }, [
              _c("li", [
                _vm._v("Instagram Creator accounts are not supported.")
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Accounts are limited to 25 API-published posts within a 24 hour period. Carousels count as a single post."
                )
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("JPEG is the only image format supported.")]),
              _vm._v(" "),
              _c("li", [_vm._v("Stories are not supported.")]),
              _vm._v(" "),
              _c("li", [_vm._v("Shopping tags are not supported.")]),
              _vm._v(" "),
              _c("li", [_vm._v("Publishing to Instagram TV is not supported.")])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("\n                      Brand:\n                      "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e9877c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9877c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramAccount/officialContentPublishing.vue
// module id = null
// module chunks = 